module.exports = __webpack_public_path__ + "static/media/userToken.88dabdc3.svg";